export default __webpack_public_path__ + "static/media/logo-large.752a1026.svg";